/**
 * PRP-FEEDBACK-1 W1 (founder ruling R4): the estimate's overhead and profit percentages.
 *
 * Contract: GET / PATCH /api/v1/imports/{parse_hash}/metadata (app/api/routes/imports.py).
 * GET gives what the export will write to the ESX PARAMS and where it came from; PATCH
 * stores the user's pair (op_source "set") through the compare-and-swap save the other
 * web edits use. Same auth/fetch path as headingsApi.ts; failures arrive as `ApiError`.
 */
import { api } from './api';

export type OpSource = 'set' | 'transcribed' | 'estimated' | 'default';

export interface OpRates {
  overhead_pct: number;
  profit_pct: number;
  op_source: OpSource;
  /** B-7515: the estimate's display name, also on the PATCH reply. */
  name?: string | null;
}

export const getImportOpRates = async (parseHash: string): Promise<OpRates> =>
  api.get(`/imports/${encodeURIComponent(parseHash)}/metadata`);

export const updateImportOpRates = async (
  parseHash: string,
  body: { overhead_pct: number; profit_pct: number },
): Promise<OpRates> => api.patch(`/imports/${encodeURIComponent(parseHash)}/metadata`, body);

/** PRP-FEEDBACK-2 (B-7515): rename the estimate; the O&P pair is untouched. */
export const updateImportName = async (parseHash: string, name: string): Promise<OpRates> =>
  api.patch(`/imports/${encodeURIComponent(parseHash)}/metadata`, { name });

/** The source wording the estimate page shows beside the pair. */
export const OP_SOURCE_LABEL: Record<OpSource, string> = {
  set: 'set on this estimate',
  transcribed: 'read from the import',
  estimated: 'estimated from the import (10/10 split)',
  default: 'default',
};
